// Field builders shared by the sections. The rules and dynamic displays of the legacy form are
// layered on later; every field starts enabled and optional.

export const YES_NO_OPTIONS = [
  { label: 'Yes', value: 'yes' },
  { label: 'No', value: 'no' },
];

const ROW = { flexDirection: 'row' };

export const yesNo = (name, label, GridProps = { xs: 12 }) => ({
  variant: 'radioGroup',
  name,
  label,
  options: YES_NO_OPTIONS,
  sx: ROW,
  GridProps,
});

export const text = (name, label, GridProps = { xs: 12, sm: 4 }) => ({
  variant: 'text',
  name,
  label,
  GridProps,
});
